import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const removeProject = graphql(gql`
  mutation removeProject($projectId: ID!, $verificationPhrase: String!) {
    removeProject(projectId: $projectId, verificationPhrase: $verificationPhrase) {
      _id
    }
  }
  `,
  {
    props({ mutate }) {
      return {
        removeProject(variables) {
          return mutate({
            variables
          })
        }
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/ProjectRemover/mutations.js